// extracted by mini-css-extract-plugin
export default {"notification":"okX4W_","closed":"d3LEmb","notificationWithAnimation":"eAQb_N","openNotification":"BrskJb","closeButton":"_b_SGU"};